@let enabled = forwardingEnabled();
<div style="display: flex; align-items: center; gap: 12px; margin-bottom: 16px;">
  <span>Email forwarding</span>
  @if (enabled === undefined) {
    <span>Loading...</span>
  } @else {
    <p-tag [severity]="enabled ? 'success' : 'danger'" [value]="enabled ? 'Enabled' : 'Disabled'"></p-tag>
    <p-button
      [label]="enabled ? 'Disable' : 'Enable'"
      [severity]="enabled ? 'danger' : 'success'"
      [loading]="forwardingLoading()"
      (onClick)="toggleForwarding()"
    ></p-button>
  }
</div>
<div style="display: flex; align-items: center; gap: 12px; margin-bottom: 16px;">
  <input type="date" pInputText [(ngModel)]="sinceDate" />
  <p-button label="Fetch emails since date" [loading]="sinceLoading()" [disabled]="!sinceDate" (onClick)="fetchSince()"></p-button>
</div>
@let result = sinceEmails();
@if (result !== undefined) {
  <p-table [value]="result">
    <ng-template pTemplate="header">
      <tr>
        <th>Status</th>
        <th>Recipient</th>
        <th>Subject</th>
        <th>Timestamp</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-email>
      <tr>
        <td><p-tag>{{ email.status }}</p-tag></td>
        <td>{{ email.recipient }}</td>
        <td>{{ email.subject }}</td>
        <td>{{ email.timestamp | date: 'dd-MM-yyyy HH:mm:ss' }}</td>
        <td><p-button (onClick)="downloadEmail(email.s3Key)">Download</p-button></td>
      </tr>
    </ng-template>
  </p-table>
}
<hr style="margin: 24px 0;" />
@if (loading$ | async) {
  <p>Loading...</p>
}
@if (emails$ | async; as emails) {
  <p-table [value]="emails" selectionMode="single">
    <ng-template pTemplate="header">
      <tr>
        <th>Id</th>
        <th>Status</th>
        <th>Recipient</th>
        <th>Subject</th>
        <th>Timestamp</th>
        <th>Error message</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-email>
      <tr [pSelectableRow]="email">
        <td>{{ email.id }}</td>
        <td>
          <p-tag>{{ email.status }}</p-tag>
        </td>
        <td>{{ email.recipient }}</td>
        <td>{{ email.subject }}</td>
        <td>
          {{ email.timestamp | date: 'dd-MM-yyyy HH:mm:ss' }}
        </td>
        <td>
          @if (email.status !== 'processed') {
            <p-tag>{{ email.errorMessage }}</p-tag>
          }
        </td>
        <td>
          <p-button (onClick)="downloadEmail(email.s3Key)">Download</p-button>
          <p-button (onClick)="retryEmail(email.s3Key, email.recipient)" [loading]="retryingEmailKey() === email.s3Key">Retry</p-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div style="display: flex; gap: 8px; margin-top: 12px; justify-content: flex-end;">
    <p-button label="Previous" icon="pi pi-arrow-left" [disabled]="!(hasPreviousPage$ | async)" (onClick)="previousPage()"/>
    <p-button label="Next" icon="pi pi-arrow-right" iconPos="right" [disabled]="!(hasNextPage$ | async)" (onClick)="nextPage()"/>
  </div>
}
